<template>
  <div class="news">
    <nav-headers />
    <div class="contents">
      <div class="in-banner">
        <div class="p-nav">
          <div class="p-title">
            <div class="p-1">EVENTS</div>
            <div class="p-2">Home / EVENTS</div>
          </div>
        </div>
        <img src="../assets/img/ny-05-EVENTS.jpg" width="100%" height="auto" />
      </div>
      <div class="pageBox waps ">
        <div class="products-nav-centers">
          <div class="products-leixing">
            <span style="margin-right: 10px;" :class="{ 'active': newType == '' }" @click="changeNew('')"> ALL
            </span>
            /
            <span style="margin-right: 10px;margin-left: 10px;" :class="{ 'active': newType == 14 }" @click="changeNew(14)"> Before
            </span>
            /
            <span style="margin-left: 10px;" :class="{ 'active': newType == 15 }" @click="changeNew(15)"> Future
            </span>
          </div>
        </div>
        <div class="products-centers">
          <div class="items" v-for="(val, index) in product" :key="index" @click="buy(val.id)">
            <div class="le">
              <div class="times">{{val.createtime}}</div>
              <div class="titles">{{val.title}}</div>
              <div class="description">{{val.description}}</div>
              <div class="slide-mores">
                <div class="slide-more ">View More</div>
              </div>
            </div>
            <div class="ri">
              <img :src="baseUrl+val.image" style="width: 100%;height: auto;"></img>
            </div>
          </div>
        </div>
        <div class="el-pages">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="currentPage"
            :page-size="pageSize" layout="prev,pager,next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <nav-footer />
  </div>
</template>
<script>
//import NavHeaders from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
export default {
  name: 'product',
  data() {
    return {
      newType: '',

      baseUrl: 'http://yingcheng.0576hs.com',
      id: this.$route.params.id,
      Factorys: [],
      currentPage: 1, // 当前页码
      pageSize: 8, // 每页显示的行数 
      total: 0,

      showSlide: '', //控制动画效果
      list: [
        {}, {}, {}, {}, {}, {},
      ],
      product: [

      ], //商品信息
      // 轮播图插件
      swiperOption: {
        autoplay: true,
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    };
  },
  components: {
    NavHeaders: () => import('@/components/NavHeaders.vue'),
    NavFooter,
  },
  watch: {
    '$route': {
      handler: function (to, from) {
        console.log('Route changed from', from.path, 'to', to);
          let self = this
          this.newType =to.params.id
          self.id = self.newType
          self.getProductList()
      },
      deep: true
    }
  },
  mounted() {
    this.getProductList();
    this.$nextTick(() => {
      this.handleAnimate()//初始化第一次加载时在视口内就执行动画
      addEventListener('scroll', this.handleAnimate);
    })
  },

  destroyed() {
    removeEventListener('scroll', this.handleAnimate);
  },
  created() {
    document.documentElement.scrollTop = "0px";
    if(this.$route.params.id!='1'){
      this.newType=this.$route.params.id
    }
    setTimeout(this.handleAnimate, 1000);
  },
  methods: {
    changeNew(val) {
      let self = this
      self.newType = val
      self.id = val
      self.getProductList()
    },
    handleAnimate() {
      let top = pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let vh = document.documentElement.clientHeight;
      let dom = document.querySelectorAll(".animate");
      [].slice.call(dom).forEach(v => {
        if (top + vh > v.offsetTop) {
          var delay = v.dataset.delay;
          if (delay) {
            setTimeout(() => {
              v.style.opacity = 1;
              v.classList.add(v.dataset.ani)
            }, delay)
          } else {
            v.style.opacity = 1;
            v.classList.add(v.dataset.ani)
          }
        } else {
          v.classList.remove(v.dataset.ani)
          v.style.opacity = 0;
        }
      })
    },
    handleCurrentChange(e) {
      let id = '26';
      this.currentPage = 1
      this.$api.mall.getEvents({ type: this.newType, limit: 8, page: e }).then((res) => {
        this.product = res.data.data.data;
        this.current_page = res.data.data.current_page
        this.total = res.data.data.total
      });
    },
    // 获取商品信息
    getProductList() {
      let id = '26';
      this.currentPage = 1
      this.$api.mall.getEvents({ type: this.newType, limit: 8, page: 1 }).then((res) => {
        this.product = res.data.data.data;
        this.current_page = res.data.data.current_page
        this.total = res.data.data.total
      });
    },
    // 购买
    buy(val) {
      //let id = this.$route.params.id;
      this.$router.push(`/eventsDetail/${val}`);
    },
    // 打开视频
    openVideo() {
      this.showSlide = 'slideDown';
    },
    // 关闭视频
    closeVideo() {
      this.showSlide = 'slideUp';
      setTimeout(() => {
        this.showSlide = '';
      }, 600);
    }
  }
};
</script>
<style lang="scss">
@media screen and (min-width: 0px) and (max-width:440px) {
  .news {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #ededed;

    //animate classs
    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }

    .el-pages {
      text-align: center;
      width: 100%;
      margin: 50px auto;
      overflow: hidden;
    }

    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;

      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
      }

      .products-leixing {
        width: 398px;
        font-size: 16px;
        color: #252525;
        //color: #00959b;
        overflow: hidden;
        margin: 25px auto;
        text-transform: uppercase;
        padding: 0px;
        box-sizing: border-box;

        .active {
          color: #00959b;
        }

        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }

      .products-centers {
        width: 90%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        min-height: 288px;
        padding: 0px 0px 0px 0px;

        .slide-mores:hover {
          background: #02999d;
          border: 1px solid #02999d;
          color: #fff;
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
        }

        .slide-mores {
          cursor: pointer;
          margin-top: 40px;
          margin-left: 12px;
          background: none;
          color: #252525;
          text-align: center;
          transform: skewX(-20deg);
          border: 1px solid #252525;
          width: 88px;
          font-size: 14px;
          line-height: 30px;

          .slide-more {
            transform: skewX(20deg);
          }
        }

        .items:hover {
          box-sizing: border-box;


        }

        .items {
          width: 100%;
          margin-top: 50px;
          float: left;
          margin-left: 2%;
          overflow: hidden;
          box-sizing: border-box;
          cursor: pointer;
          padding-bottom: 50px;
          border-bottom: 1px solid #d9d9d9;



          .le {
            width: 49%;
            overflow: hidden;
            float: left;
            padding: 0px;
          }

          .ri {
            width: 49%;
            overflow: hidden;
            float: right;

            padding: 0px;
          }

          .description {
            display: none;
          }

          .titles {
            color: #252525;
            font-weight: 600;
            font-size: 20px;
            margin-top: 20px;
          }

          .times {
            color: #00959b;
            font-size: 16px;
          }
        }
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;
      img{
        width: 150%;
        height: auto;
      }

      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;

        .p-title {
          width: 188px;
          margin: 0px auto;
          box-sizing: border-box;
          padding: 0px;
          text-align: center;  
          text-transform: uppercase;

          overflow: hidden;

          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }

          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }

    .contents {
      width: 100%;
      min-width: 0px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 61px;

    }
  }
}

@media screen and (min-width: 1024px) and (max-width:1600px) {
  .news {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #ededed;

    //animate classs
    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }

    .el-pages {
      text-align: center;
      width: 100%;
      margin: 50px auto;
      overflow: hidden;
    }

    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;

      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
      }

      .products-leixing {
        width: 398px;
        color: #252525;
        text-transform: uppercase;

        //color: #00959b;
        overflow: hidden;
        margin: 50px auto;
        padding: 0px;
        box-sizing: border-box;

        .active {
          color: #00959b;
        }

        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }

      .products-centers {
        width: 1200px;
        overflow: hidden;
        margin: 40px auto auto auto;
        box-sizing: border-box;
        padding: 0px 0px 0px 0px;
        min-height: 608px;
        column-count: 2;
        column-gap: 35px;

        .slide-mores:hover {
          background: #02999d;
          border: 1px solid #02999d;
          color: #fff;
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
        }

        .slide-mores {
          cursor: pointer;
          margin-top: 50px;
          margin-left: 12px;
          background: none;
          color: #252525;
          text-align: center;
          transform: skewX(-20deg);
          border: 1px solid #252525;
          width: 88px;
          font-size: 14px;
          line-height: 30px;

          .slide-more {
            transform: skewX(20deg);
          }
        }

        .items:hover {
          box-sizing: border-box;


        }

        .items {
          width: 100%;
          margin-top: 50px;
          float: left;
          margin-left: 2%;
          overflow: hidden;
          box-sizing: border-box;
          cursor: pointer;
          padding-bottom: 50px;
          border-bottom: 1px solid #d9d9d9;



          .le {
            width: 49%;
            overflow: hidden;
            float: left;
            padding: 0px;
          }

          .ri {
            width: 49%;
            overflow: hidden;
            float: right;
            padding: 0px;
          }

          .description {
            color: #b9b9b9;
            width: 100%;
            margin-top: 25px;
            overflow: hidden;
            font-weight: 400;
          }

          .titles {
            color: #252525;
            font-weight: 600;
            font-size: 25px;
            margin-top: 20px;
          }

          .times {
            color: #00959b;
            font-size: 16px;
          }
        }
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;
  

      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;

        .p-title {
          width: 188px;
          margin: 0px auto;
          box-sizing: border-box;
          padding: 0px;
          text-align: center;
          overflow: hidden;

          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }

          .p-2 {
            color: #0299a5;
            font-size: 16px;
            text-transform: uppercase;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }

    .contents {
      width: 100%;
      min-width: 1350px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 75px;

    }
  }
}

@media screen and (min-width: 1601px) and (max-width:8000px) {
  .news {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #ededed;

    //animate classs
    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }

    .el-pages {
      text-align: center;
      width: 100%;
      margin: 50px auto;
      overflow: hidden;
    }

    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;

      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
      }

      .products-leixing {
        width: 398px;
        color: #252525;
        text-transform: uppercase;

        //color: #00959b;
        overflow: hidden;
        margin: 50px auto;
        padding: 0px;
        box-sizing: border-box;

        .active {
          color: #00959b;
        }

        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }

      .products-centers {
        width: 1600px;
        overflow: hidden;
        margin: 40px auto auto auto;
        box-sizing: border-box;
        padding: 0px 0px 0px 0px;
        min-height: 608px;
        column-count: 2;
        column-gap: 35px;

        .slide-mores:hover {
          background: #02999d;
          border: 1px solid #02999d;
          color: #fff;
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
        }

        .slide-mores {
          cursor: pointer;
          margin-top: 50px;
          margin-left: 12px;
          background: none;
          color: #252525;
          text-align: center;
          transform: skewX(-20deg);
          border: 1px solid #252525;
          width: 88px;
          font-size: 14px;
          line-height: 30px;

          .slide-more {
            transform: skewX(20deg);
          }
        }

        .items:hover {
          box-sizing: border-box;


        }

        .items {
          width: 100%;
          margin-top: 50px;
          float: left;
          margin-left: 2%;
          overflow: hidden;
          box-sizing: border-box;
          cursor: pointer;
          padding-bottom: 50px;
          border-bottom: 1px solid #d9d9d9;



          .le {
            width: 49%;
            overflow: hidden;
            float: left;
            padding: 0px;
          }

          .ri {
            width: 49%;
            overflow: hidden;
            float: right;
            padding: 0px;
          }

          .description {
            color: #b9b9b9;
            width: 100%;
            margin-top: 25px;
            overflow: hidden;
            font-weight: 400;
          }

          .titles {
            color: #252525;
            font-weight: 600;
            font-size: 25px;
            margin-top: 20px;
          }

          .times {
            color: #00959b;
            font-size: 16px;
          }
        }
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;
  

      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;

        .p-title {
          width: 188px;
          margin: 0px auto;
          box-sizing: border-box;
          padding: 0px;
          text-align: center;
          overflow: hidden;

          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }

          .p-2 {
            color: #0299a5;
            font-size: 16px;
            text-transform: uppercase;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }

    .contents {
      width: 100%;
      min-width: 1350px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 75px;

    }
  }
}
</style>